import { useAppSelector } from "@hypexone/uicore";
import { useCountdown } from "../../../utils/hooks/countdown.hooks";

// One-click betting loading component with countdown
const OneClickBettingCountdown: React.FC<{ delay: number; compact?: boolean }> = ({
  delay,
  compact,
}) => {
  const { langData } = useAppSelector((state) => state.cms);
  // Compact: one row high, for a single line on the sports list.
  if (compact) {
    return (
      <div className="absolute inset-0 z-20 flex items-center justify-center gap-2 bg-black/30 backdrop-blur-[2px]">
        <div className="relative h-[30px] w-[30px] flex items-center justify-center">
          <CountdownDisplay delay={delay} compact />
          <div className="h-full w-full border-[3px] border-white rounded-full border-dotted border-t-white border-b-oneClickLoadingSpinner border-x-oneClickLoadingSpinner animate-oneClickLoadingSpinnerAnimation"></div>
        </div>
        <div className="text-xs font-semibold text-white">
          {langData?.["yourBettingIsBeingProcessed"] ?? "Your bet is being processed"}...
        </div>
      </div>
    );
  }
  return (
    <div className="absolute top-0 left-0 flex flex-col gap-1 items-center justify-center w-full h-full z-20 bg-black/30 backdrop-blur-[2px]">
      <div className="relative h-[70px] w-[70px] flex items-center justify-center">
        <CountdownDisplay delay={delay} />
        <div className="h-[80%] w-[80%] border-4 border-white rounded-full border-dotted border-t-white border-b-oneClickLoadingSpinner border-x-oneClickLoadingSpinner animate-oneClickLoadingSpinnerAnimation"></div>
      </div>
      <div className="flex flex-col items-center justify-center text-white">
        <div className="text-sm font-semibold">
          {langData?.["yourBettingIsBeingProcessed"] ?? "Your bet is being processed"}...
        </div>
        <div className="text-xs text-suspendedBg">
          {langData?.["pleaseWait"] ?? "Please wait"}
        </div>
      </div>
    </div>
  );
};

export default OneClickBettingCountdown;

// Countdown display component
const CountdownDisplay: React.FC<{ delay: number; compact?: boolean }> = ({
  delay,
  compact,
}) => {
  const count = useCountdown(delay);
  return (
    <div className={`absolute ${compact ? "text-xs" : "text-lg"} text-white`}>
      {delay === 0 ? "0" : count}
    </div>
  );
};
